import { render, staticRenderFns } from "./AddTravelItemModal.vue?vue&type=template&id=62e982c6&scoped=true&"
import script from "./AddTravelItemModal.vue?vue&type=script&lang=js&"
export * from "./AddTravelItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e982c6",
  null
  
)

export default component.exports